// extracted by mini-css-extract-plugin
module.exports = {"shipsFrom":"corner-css_shipsFrom__ulSZ4"};